import * as ReactGA from "react-ga";

window.clevertap = {
  event: [],
  profile: [],
  account: [],
  onUserLogin: [],
  notifications: [],
  privacy: [{ optOut: false }, { useIP: false }],
};

/**
 * @deprecated use `useGoogleAnalytics` instead
 */
export const useAnalytics = (overrideCategory?: string) => {
  const prefix = "Ob_";

  return {
    sendEvent: (action: string, label = ""): void => {
      ReactGA.event({
        category: overrideCategory || "Passport",
        action,
        label,
      });
    },
    sendCustomEvent: (category: string, action: string, label = ""): void => {
      ReactGA.event({
        category,
        action,
        label,
      });
    },
    prefix,
  };
};
